import React from "react";
import './Footer.css';

const Footer = () => {
    return (
        <footer className="bg-blue w-100 mt-5 py-3">
            <div className="row g-0">
                <div className="col-12 col-lg-6">
                    <ul className="text-white fw-bolder d-flex gap-lg-3 p-0 justify-content-center flex-wrap gap-3">
                        <a href="#">
                            <li className="title-section">Home</li>
                        </a>
                        <a href="#sobre">
                            <li className="title-section">Sobre</li>
                        </a>
                        <a href="#atuacao">
                            <li className="title-section">Atuação</li>
                        </a>
                        <a href="#advogados">
                            <li className="title-section">Advogados</li>
                        </a>
                        <a href="#contatos">
                            <li className="title-section">Contatos</li>
                        </a>
                    </ul>
                </div>
                <div className="col-12 col-lg-6 d-flex justify-content-center mt-3 mt-lg-0">
                    <span className="text-center text-white">©Rodrigues & Mafra<br/>2024</span>
                </div>
            </div>
        </footer>
    );
}

export default Footer;